<template>
  <div class="main-body">
    <div class="header">打卡记录</div>
    <div class="out">
      <div class="search2">

        <div style="float:right">

          <el-input  placeholder="输入姓名" v-model="name" clearable style="width:120px;margin-right:10px"></el-input>
          <el-input  placeholder="输入身份证号" v-model="idCard" clearable maxlength="18" style="width:200px;margin-right:10px"></el-input>
          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0" placeholder="请选择所属区域" v-on:getZoneValue="getZoneValue" style="width:200px;margin-right:10px"></elSelectTree>

          <el-date-picker style="margin-right: 10px;width:250px;" title="起止时间" size="mini"
                          v-model="startEndTime"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间">
          </el-date-picker>

          <el-button type="primary" size="mini" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border >
        <el-table-column prop="elderly.name" label="老人姓名" width="85"></el-table-column>
        <el-table-column prop="elderly.idCard" label="身份证号" width="200"></el-table-column>
        <el-table-column prop="elderly.phone" label="手机号" width="150"></el-table-column>
        <el-table-column prop="elderly.zoneName" label="所属区域" width="300"></el-table-column>
        <el-table-column prop="serve.name" label="服务人员"  width="85"></el-table-column>
        <el-table-column label="拍照图片" width="100">
          <template slot-scope="scope">
            <el-popover placement="right" title="" trigger="click" v-if="scope.row.imgUrl">
              <img :src="imgUrl+scope.row.imgUrl+'_watermark.jpg'"  style="width: 500px"/>
              <img slot="reference" :src="imgUrl+scope.row.imgUrl+'_watermark.jpg'" style="width:100%">
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="打卡地址" width="200"></el-table-column>
        <el-table-column prop="remark" label="备注"  width="300"></el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="创建时间"></el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>
  </div>
</template>

<script>

import {timeStr,timefilters,getMonthDay} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import elSelectTree from "@/components/ElSelectTree"
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Role",
  data(){
    return{
      loading:false,
      tableData:null,
      datetimerangeValue:'',
      totalItems: 0,
      pageSize:20,
      name:'',
      idCard:'',
      startTime:'',
      endTime:'',
      imgUrl:this.$imgUrl,
      currentPage:1,
      zoneValue:[],
      zoneCode:'00000000-0000-0000-0000-000000000000',
      th:0,
      zoneProps:{
        emitPath:false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },

      startEndTime:[],

    }
  },
  components:{
    elSelectTree
  },
  created(){


    const end = new Date();
    const start = new Date(end - 1000 * 60 * 60 * 24 * 365);
    this.startEndTime = [start, end];

    this.init();
    this.getList();
    this.th = this.$store.state.tableHeight;

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      console.log(val);
      this.th = val;
    },
  },
  methods:{
    init(){
      this.endTime = getMonthDay("e",0);
      this.startTime = getMonthDay("s",0);
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              var data=JSON.stringify(response.data.data);
              data=JSON.parse(data.replace(/"listZoneDTO":\[\],/g,''))
              this.zoneValue = data;
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )
    },
    download(){
      this.$confirm('是否导出当前列表?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.showModal=true
        var that=this
        var zoneCode='00000000-0000-0000-0000-000000000000'
        if(this.zoneCode){
          zoneCode=this.zoneCode
        }
        this.$axios.get(this.$shopUrl+'ElderlyClockin/ExportElderlyClockin',{
          responseType: 'blob',
          params:{
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            staffCode: getStaffCode(),
            idCard: this.idCard,
            //startTime:this.startTime,
            //endTime:this.endTime,
            zoneCode:zoneCode,
            name:this.name,

            startTime: timefilters(this.startEndTime[0]),
            endTime: timefilters(this.startEndTime[1]),

          }
        }).then(
            (response) => {
              if (response.data.type === 'application/json') {
                this.$message({type: 'info', message: '暂无数据'});
                that.showModal = false;
              } else {
                let fileName = '服务对象打卡记录.xlsx';
                that.file(response, fileName);
                that.showModal = false;
                this.$message({type: 'success', message: '导出成功'});
              }

            }
        )
        this.dialogFormVisible=false
      }).catch(e=>e)
    },
    file(response, fileName) {
      let blob = new Blob([response.data]);
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        let elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      }
    },
    getZoneValue(val){
      this.zoneCode=val
    },
    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },
    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },
    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1
      var zoneCode='00000000-0000-0000-0000-000000000000'
      if(this.zoneCode){
        zoneCode=this.zoneCode
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ElderlyClockin/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name: this.name,
          idCard: this.idCard,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          //startTime:this.startTime,
          //endTime:this.endTime,
          zoneCode:zoneCode,

          startTime: timefilters(this.startEndTime[0]),
          endTime: timefilters(this.startEndTime[1]),

        }
      }).then( (response)=> {
        console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    statusTitle(row){
      if(row.status == 0){
        return "正常";
      }
      if(row.status == 1){
        return "禁用";
      }
      return "其它";
    },



  }
}
</script>

<style scoped>

</style>
